import { useEffect, useState } from 'react';
import { Button, Card, Modal, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  connectedML,
  getTotalProperties,
  getUrlML,
  singOut,
  syncProperties
} from 'redux/mlSlice';

export const ButtonMl = () => {
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.ml);

  const [loadingML, setLoadingML] = useState(false);
  const [loadingProps, setLoadingProps] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleClick = async () => {
    if (loadingML) return;
    setLoadingML(true);

    if (!user) {
      const response = await dispatch(getUrlML());

      if (response.status === 200) {
        window.location.replace(response.data);
      }
    } else {
      dispatch(singOut());
    }

    setLoadingML(false);
  };

  const handleSyncProperties = async () => {
    if (loadingProps) return;
    setLoadingProps(true);
    await dispatch(syncProperties());
    dispatch(getTotalProperties());
    setLoadingProps(false);
    setShowModal(false);
  };

  useEffect(() => {
    !user && setLoadingML(false);
    if (!user) {
      setLoadingML(false);
      dispatch(connectedML());
    } else {
      dispatch(getTotalProperties());
    }
  }, [user]);

  return (
    <>
      <Card.Header className="w-100 d-flex justify-content-between">
        <Button
          variant="primary"
          onClick={() => setShowModal(true)}
          style={{
            width: '283px',
            position: 'absolute',
            opacity: user ? 1 : 0,
            transition: 'opacity 0.3s ease'
          }}
        >
          Sincronizar propiedades
        </Button>
        <Button
          variant="primary"
          onClick={handleClick}
          disabled={loadingML}
          style={{
            position: 'relative',
            width: loadingML ? 'fit-content' : '283px',
            left: loadingML ? '50%' : user ? 'calc(100% - 283px)' : '0',
            transform: loadingML ? 'translateX(-50%)' : user ? 'none' : 'none',
            transition: 'all 0.3s ease',
            overflow: 'hidden',
            maxHeight: '72px'
          }}
        >
          {loadingML ? (
            <div className="d-flex align-items-center">
              <span>Siga las instrucciones en la nueva ventana</span>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="ms-2"
              />
            </div>
          ) : user ? (
            'Desvincular mi cuenta de Mercado Libre'
          ) : (
            'Conectar con Mercado Libre'
          )}
        </Button>
        <style>
          {`
            @media (max-width: 576px) { 
                .btn {
                    width: 100% !important;
                    max-width: none !important;
                    left: 0 !important;
                    transform: none !important;
                }
            }
            `}
        </style>
      </Card.Header>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            ¿Está seguro que desea importar las propiedades de Mercado Libre?
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            Se importarán todas las propiedades que tengas en Mercado Libre.
            <b> Tené en cuenta que el proceso puede demorar varios minutos.</b>
          </p>

          <p className="text-center">
            <strong className="text-danger fs-1">
              Esta acción no se puede deshacer.
            </strong>
          </p>

          <p className="m-0 text-end">¿Desea continuar?</p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>

          {loadingProps ? (
            <Button
              variant="warning"
              if={loadingProps}
              disabled={loadingProps}
              className="d-inline-flex flex-center gap-1"
            >
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              Sincronizando...
            </Button>
          ) : (
            <Button
              variant="warning"
              onClick={handleSyncProperties}
              disabled={loadingProps}
            >
              Sincronizar
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};
